<template>
  <transition
    name="fade-slide"
    @enter="onEnter"
    @leave="onLeave"
  >
    <slot />
  </transition>
</template>

<script>
  export default {
    name: 'accordeon-wrapper',
    methods: {
      onEnter (el) {
        el.style.overflow = 'hidden' // Чтобы избежать переполнения во время анимации
        el.style.height = '0'
        el.style.opacity = '0'
        el.style.transform = 'translateY(-10px)'
        const height = el.scrollHeight + 'px'
        requestAnimationFrame(() => {
          el.style.transition = 'height 0.2s ease, opacity 0.2s ease, transform 0.2s ease'
          el.style.height = height
          el.style.opacity = '1'
          el.style.transform = 'translateY(0)'
        })
        // После анимации вернём overflow обратно
        setTimeout(() => {
          el.style.overflow = ''
        }, 150)
      },
      onLeave (el) {
        el.style.overflow = 'hidden'
        el.style.height = el.scrollHeight + 'px'
        el.style.opacity = '1'
        el.style.transform = 'translateY(0)'
        requestAnimationFrame(() => {
          el.style.transition = 'height 0.1s ease, opacity 0.1s ease, transform 0.1s ease'
          el.style.height = '0'
          el.style.opacity = '0'
          el.style.transform = 'translateY(-10px)'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/vue/common/UI/AccordeonWrapper.vue